import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';  
import axios from 'axios';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { HistoryListHead, HistoryListToolbar,  HistoryMoreMenu} from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'fromyear', label: 'From Year', alignRight: false },
  { id: 'toyear', label: 'To Year', alignRight: false }, 
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'images', label: 'Images', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((history) => {
      if (String(history.fromyear).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (String(history.toyear).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (history.description && history.description.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (history.images && String(history.images).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      return false;
    });
  }
  

  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter((history) =>
      history.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function History() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('email'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for historys
  const [histories, setHistories] = useState([]);
  const [editinghistoryId, setEditingHistoryId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [fromyear, setFromYear] = useState('');
  const [toyear, setToYear] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState('');
  const [selectedhistory, setSelectedHistory] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);




  // Fetch historys from the server on component mount
  useEffect(() => {
    fetchhistorys();
  }, []);

  // Fetch historys from the server
  const fetchhistorys = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/history/history'); 
      const sortedHistories = [...response.data].sort(
          (a, b) => b.fromyear - a.fromyear
        );
      setHistories(sortedHistories);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = histories.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing history
  const handleOpenModal = (historyId) => {
    if (historyId) {

      const historytoEdit = histories.find(history=> history._id === historyId);
      if(historytoEdit){
        setFromYear(historytoEdit.fromyear);
        setToYear(historytoEdit.toyear);
        setDescription(historytoEdit.description);
        setImages(historytoEdit.images);
        setEditingHistoryId(historyId);
      }
    } else {
      setFromYear('');
      setToYear('');
      setDescription('')
      setImages('');
      setEditingHistoryId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setFromYear('');
    setToYear('');
    setDescription('')
    setImages('');
    setEditingHistoryId(null);

  };



  // Handle adding a new history
  const handleAddhistory = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/history/',{ fromyear,toyear,description,images }); // Adjust based on your actual data structure

      fetchhistorys(); // Refresh history list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding history:", error);
    }
  };

  // Handle updating a history
  const handleUpdatehistory = async () => {
    try {
      await axios.put(`https://cpccbe.org/api/history/update-history/${editinghistoryId}`, { fromyear,toyear,description,images }); // Adjust endpoint as necessary
      fetchhistorys(); // Refresh history list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating history:", error);
    }
  };

  // Handle deleting a history
  const handleDeletehistory = async (historyId) => {
    if (window.confirm("Are you sure you want to delete this history?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/history/${historyId}`); // Adjust endpoint as necessary
        fetchhistorys(); // Refresh history list after deletion
      } catch (error) {
        console.error("Error deleting history:", error);
      }
    }
  };

  const handleViewhistory = (history) => {
    // Open a modal or set state to display history details
    setSelectedHistory(history); // Assuming you have state to hold selected history data
    setViewModalOpen(true); // Open the modal for viewing history details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - histories.length) : 0;

  // Apply sorting and filtering
  const filteredhistorys = applySortFilter(histories, getComparator(order, orderBy), filterName, roleFilter);


  const ishistoryNotFound = filteredhistorys.length === 0;
  
  return (
    <Page title="history">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            History
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New History
          </Button>
        </Stack>

        <Card>
          <HistoryListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <HistoryListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={histories.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredhistorys.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, email, role } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(email) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
<TableCell align="left">
  <IconButton onClick={() => handleViewhistory(row)} aria-label="view history">
    <Iconify icon="eva:eye-fill" />
  </IconButton>
</TableCell>
                       
                        <TableCell align="left">{row.fromyear}</TableCell>
                        <TableCell align="left">{row.toyear}</TableCell>
                        <TableCell align="left">{row.description}</TableCell>
                        <TableCell align="left">{row.images}</TableCell>
                        <TableCell align="left">
                          <HistoryMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletehistory(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {ishistoryNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={histories.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing history */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editinghistoryId ? "Edit history" : "Add New history"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="fromyear"
              label="From Year"
              type="text"
              fullWidth
              value={fromyear}
              onChange={(e) => setFromYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="toyear"
              label="To Year"
              type="text"
              fullWidth
              value={toyear}
              onChange={(e) => setToYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="description"
              label="Description"
              type="text"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <TextField
              margin="dense"
              id="images"
              label="Images(For multiple images, separate URLs with a space)"
              type="text"
              fullWidth
              value={images}
              onChange={(e) => setImages(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editinghistoryId ? (
              <Button onClick={handleUpdatehistory}>Update history</Button>
            ) : (
              <Button onClick={handleAddhistory}>Add history</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>History Details</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="fromyear"
              label="From Year"
              type="text"
              fullWidth
              value={selectedhistory?.fromyear}
              disabled
              />
            <TextField
              margin="dense"
              id="toyear"
              label="To Year"
              type="text"
              fullWidth
              value={selectedhistory?.toyear}
              disabled
              />
            <TextField
              margin="dense"
              id="description"
              label="Description"
              type="text"
              fullWidth
              value={selectedhistory?.description}
              disabled
              />
            <TextField
              margin="dense"
              id="images"
              label="Images"
              type="text"
              fullWidth
              value={selectedhistory?.images}
              disabled
              />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
